/**
 * Fires a Navigation.PageView signal every time the route changes.
 * Must be rendered inside <BrowserRouter>.
 * Renders nothing — purely a side-effect component.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { EVENTS, getPageName } from '@constants/telemetryEvents';
import { useAuth } from '@contexts/AuthContext';
import { applyPublicSearchMeta } from '@utils/documentHead';
import { getCampaignParams, getExternalReferrerHost } from '@utils/telemetryCampaign';
import { signal } from '@utils/telemetry';

export function RouteTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    applyPublicSearchMeta(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const campaign = getCampaignParams(location.search);
    const referrerHost = getExternalReferrerHost();

    void signal(EVENTS.PAGE_VIEW, {
      path: location.pathname,
      pageName: getPageName(location.pathname),
      visitorState: user ? 'authenticated' : 'anonymous',
      ...(referrerHost ? { referrerHost } : {}),
      ...campaign,
    });
  }, [location.pathname, location.search, user]);

  return null;
}
